<template>
  <div class="vd-gl-content">
    <!-- 内容 -->
    <a-tabs type="card" @change="tabChange">
      <template v-for="item in cate_list">
        <a-tab-pane :key="item.value" :tab="item.name">
          <a-table
            size="small"
            :data-source="dataList"
            row-key="id"
            :pagination="false"
          >
            <a-table-column title="id" data-index="id" />
            <a-table-column title="父级" data-index="pid" />
            <a-table-column title="类型" data-index="type" />
            <a-table-column title="权重" data-index="weigh" />
            <a-table-column title="状态" data-index="status">
              <template slot-scope="text, record">
                <a-switch
                  checked-children="正常"
                  un-checked-children="禁用"
                  @click="statusChange(record)"
                  :checked="text === 'normal'"
                />
              </template>
            </a-table-column>
            <a-table-column title="名称" data-index="name" />
            <a-table-column title="昵称" data-index="nickname" />
            <a-table-column title="标识" data-index="flag">
              <template slot-scope="text, record">
                <template v-if="record.type === 'book_sub_type'">
                  {{ formatDate(text) }}
                </template>
                <template v-else>
                  {{ text }}
                </template>
              </template>
            </a-table-column>
            <a-table-column title="图标" data-index="image" />
            <a-table-column title="关键词" data-index="keywords" />
            <a-table-column title="描述" data-index="description" />
            <a-table-column title="别名" data-index="diyname" />
            <a-table-column title="操作" align="center">
              <template slot-scope="record">
                <template v-if="record.type === 'book_sub_type'">
                  <a-date-picker
                    :showToday="false"
                    format="YYYY-MM-DD"
                    placeholder="设置考试时间"
                    :disabled-date="disabledDate"
                    @change="
                      (date) => {
                        timeChange(date, record)
                      }
                    "
                  >
                    <a-tag>设置考试时间</a-tag>
                  </a-date-picker>
                </template>
                <template v-if="record.type === 'item_type'">
                  <a-tag color="blue" @click="typeChange(record)">修改</a-tag>
                  <a-popconfirm
                    title="确定删除此类别?"
                    ok-text="删除"
                    cancel-text="取消"
                    @confirm="typeDelete(record)"
                  >
                    <a-icon
                      slot="icon"
                      type="question-circle-o"
                      style="color: red"
                    />
                    <a-tag color="red">删除</a-tag>
                  </a-popconfirm>
                </template>
              </template>
            </a-table-column>
          </a-table>
        </a-tab-pane>
      </template>
    </a-tabs>

    <a-modal :visible="visible" @cancel="typeCancel" @ok="typeOk">
      <a-form-model
        ref="checkForm"
        :model="form"
        :label-col="{ span: 4 }"
        :wrapper-col="{ span: 14 }"
      >
        <a-form-model-item label="项目名称" prop="name">
          <a-input
            class="vd-input-s"
            v-model="form.name"
            placeholder="确认输入名称"
            type="text"
            autocomplete="off"
          />
        </a-form-model-item>
        <a-form-model-item label="权重" prop="weigh">
          <a-input-number class="vd-input-xs" v-model="form.weigh" />
        </a-form-model-item>
      </a-form-model>
    </a-modal>
  </div>
</template>
<script>
import {
  getCateList,
  categoryByType,
  setTestTime,
  categoryModify,
  type_change,
} from '@/api'
import moment from 'moment'
import 'moment/locale/zh-cn'

export default {
  name: 'CategoryIndex',
  data() {
    return {
      visible: false,
      labelCol: { span: 3 },
      wrapperCol: { span: 14 },
      // ---------
      cate_list: [],
      dataList: [],
      now_type: 0,
      form: {
        id: undefined,
        name: undefined,
        weigh: 0,
      },
    }
  },
  mounted() {
    getCateList().then((res) => {
      if (res['code'] === 1) {
        this.cate_list = res['type_list']
        this.now_type = this.cate_list[0]['value']
        this.getData()
      } else {
        this.$message.warning(res['msg'])
      }
    })
  },
  methods: {
    moment,
    getData() {
      categoryByType({
        type: this.now_type,
      }).then((res) => {
        if (res['code'] === 1) {
          this.dataList = res['tree']
        } else {
          this.$message.warning(res['msg'])
        }
      })
    },
    tabChange(e) {
      this.now_type = e
      this.getData()
    },
    statusChange(item) {
      let status
      if (item.status === 'normal') {
        status = 'hidden'
      } else {
        status = 'normal'
      }
      // 分类
      categoryModify({
        id: item.id,
        data: {
          status: status,
        },
      }).then((res) => {
        if (res['code'] === 1) {
          item.status = status
        } else {
          this.$message.warning(res['msg'])
        }
      })
    },
    timeChange(value, item) {
      item.flag = value
      // save time
      setTestTime({
        id: item.id,
        date: item.flag,
        type: item.type,
      }).then((res) => {
        if (res['code'] === 1) {
          this.$message.success(res['msg'])
        } else {
          item.flag = 0
          this.$message.warning(res['msg'])
        }
      })
    },
    disabledDate(current) {
      // Can not select days before today and today
      return current && current < moment().startOf('day')
    },
    formatDate(timestamp) {
      if (typeof timestamp === 'number') {
        if (timestamp === 0) {
          return '未设置考试时间'
        } else {
          return moment(timestamp * 1000).format('YYYY/MM/DD')
        }
      } else {
        return moment(timestamp).format('YYYY/MM/DD')
      }
    },
    typeChange(record) {
      this.visible = true
      this.form.id = record.id
      this.form.name = record.name
      this.form.weigh = record.weigh
    },
    typeCancel() {
      this.visible = false
      this.form.id = undefined
      this.form.weigh = 0
    },
    typeOk() {
      type_change(this.form).then((res) => {
        this.visible = false
        if (res.code === 1) {
          this.$message.success(res.msg)
          this.getData()
        } else {
          this.$message.warning(res.msg)
        }
      })
    },
    typeDelete(record) {
      console.log(record)
    },
  },
}
</script>

<style scoped></style>
